import { theme, withProp } from 'styled-tools';

import Section from '@/components/ui/Section';
import SocialLinks from '@/components/SocialLinks';
import styled from 'styled-components';
import { transparentize } from 'polished';

const AdjustedSection = styled(Section)`
  padding-bottom: 6rem;

  .profile-header {
    color: var(--color-blue);

    h1 {
      margin-top: 0;
      margin-bottom: 1rem;
      font-size: 2rem;
      font-weight: 700;
    }

    h2 {
      margin-top: 0;
      margin-bottom: 1rem;
    }
  }
`;

const ArrowLink = styled.a`
  color: ${theme('colors.orange')};
  transition: all 0.3s ease-out;
  transform-origin: right top;
  :hover {
    box-shadow:
      4px 4px 0px 0px ${withProp('theme.colors.darkOrange', transparentize(0.5))},
      8px 8px 0px 0px ${withProp('theme.colors.darkOrange', transparentize(0.75))};
  }
`;

const StyledSocialLinks = styled(SocialLinks)`
  margin-bottom: 1rem;
`;

export { AdjustedSection, ArrowLink, StyledSocialLinks };
